var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callback text-center"},[_vm._v(" Sie werden in wenigen Sekunden weitergeleitet "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"size":18,"width":2,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }